import { render, staticRenderFns } from "./ArchiveWidget.vue?vue&type=template&id=f1e48570&"
import script from "./ArchiveWidget.vue?vue&type=script&lang=js&"
export * from "./ArchiveWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports